import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../Elements/Modal/Modal";
import MainButton from "../Elements/MainButton/MainButton";
import SecondButton from "../Elements/SecondButton/SecondButton";
import MainInput from "../Elements/MainInput/MainInput";
import AffiliationModalStatus from "../Affiliation/AffiliationModalStatus";
import AffiliationService from "../../services/AffiliationService";
import "./AdminModalForm.css";

const AdminEditAffiliateModal = ({ isOpen, onClose, affiliate, onUpdated }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    one_off_mrg: 0,
    first_mrg: 0,
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (isOpen && affiliate) {
      // Zamiana wartości ułamkowych z backendu (np. 0.3) na wartości procentowe w formularzu (np. 30)
      setFormData({
        one_off_mrg: affiliate.one_off_mrg != null ? Math.round(affiliate.one_off_mrg * 100) : 0,
        first_mrg: affiliate.first_mrg != null ? Math.round(affiliate.first_mrg * 100) : 0,
      });
      setError("");
      setSuccess("");
    }
  }, [isOpen, affiliate]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((previous) => ({
      ...previous,
      [name]: value === "" ? "" : Number(value),
    }));
    setError("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (saving || !affiliate) return;

    try {
      setSaving(true);
      setError("");

      // Przeliczenie wpisanych procentów (np. 30) z powrotem na ułamek dla API (np. 0.3)
      const payload = {
        one_off_mrg: (Number(formData.one_off_mrg) || 0) / 100,
        pay_go_mrg: 0,
        first_mrg: (Number(formData.first_mrg) || 0) / 100,
      };

      const affiliateId = affiliate.affiliate_user || affiliate.id || affiliate.wallet_id;
      await AffiliationService.updateAdminAffiliate(affiliateId, payload);

      setSuccess(t("adminAffiliation.updateSuccess", "Affiliate updated successfully."));
      onUpdated?.();
    } catch (requestError) {
      const detail = requestError.response?.data?.detail;
      setError(
        typeof detail === "string" ? detail : requestError.message || t("errors.generic", "Something went wrong"),
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={saving ? () => {} : onClose}
      title={t("adminAffiliation.editAffiliate", "Edit Affiliate")}
      actions={
        success ? (
          <MainButton onClick={onClose}>{t("common.close", "Close")}</MainButton>
        ) : (
          <>
            <SecondButton onClick={onClose} disabled={saving}>
              {t("common.cancel", "Cancel")}
            </SecondButton>
            <MainButton onClick={handleSubmit} disabled={saving}>
              {saving ? t("common.saving", "Saving...") : t("common.save", "Save")}
            </MainButton>
          </>
        )
      }
    >
      <form id="admin-edit-affiliate-form" onSubmit={handleSubmit} className="admin-modal-form">
        <fieldset className="admin-modal-fieldset" disabled={Boolean(success)}>
          <label>
            {t("affiliation.firstMrg", "First Margin (%)")}
            <MainInput
              type="number"
              name="first_mrg"
              value={formData.first_mrg}
              onChange={handleChange}
              disabled={saving}
              step="1"
              min="0"
              max="100"
              placeholder="30"
            />
          </label>

          <label>
            {t("affiliation.oneOffMrg", "One-off Margin (%)")}
            <MainInput
              type="number"
              name="one_off_mrg"
              value={formData.one_off_mrg}
              onChange={handleChange}
              disabled={saving}
              step="1"
              min="0"
              max="100"
              placeholder="10"
            />
          </label>
        </fieldset>
        <AffiliationModalStatus
          error={error}
          success={success}
          onErrorClose={() => setError("")}
          onSuccessClose={onClose}
        />
      </form>
    </Modal>
  );
};

export default AdminEditAffiliateModal;
